<template>
  <a-card :bordered="false">
    <search-page-view
      ref="table"
      rowKey="fengYeTeamProductId"
      :itemNames="['search_proId','search_proName','create_button',]"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_proId" label="金枫叶产品ID" v-bind="formItemLayout">
        <a-input v-model="queryParams.fengYeProductId" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_proName" label="产品名称" v-bind="formItemLayout">
        <a-input v-model="queryParams.fengYeProductName" placeholder="请输入"></a-input>
      </a-form-item>
      <div slot="action" slot-scope="data">
        <a @click="onPreview(data.record)">预览</a>
      </div>
    </search-page-view>
  </a-card>
</template>

<script>
import RouterSwitchHelper from '@/utils/helper/RouterSwitchHelper'

export default {
  name: 'ProductList',
  data() {
    return {
      isClick: true,
      queryParams: {},
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '金枫叶产品ID',
          dataIndex: 'fengYeTeamProductId',
          width: '200px'
        },
        {
          title: '产品名称',
          dataIndex: 'proName',
          width: '30%'
        },
        {
          title: '类型',
          dataIndex: 'proTypeName'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime'
        },
        {
          title: '供应商名称',
          dataIndex: 'supplierName'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      formItemLayout: {
        labelCol: {
          xxl: { span: 6 },
          xl: { span: 7 },
          lg: { span: 8 },
          sm: { span: 9 },
          md: { span: 10 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 18 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 17 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 16 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 15 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 14 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ProductList', title: '同步产品' },
      { name: 'AccountList', title: '关联账号' }
    ])
  },
  methods: {
    //预览手机页面的详情
    onPreview(record) {
      const merchantId = this.$store.getters.userInfo.merchantId
      const character = 1
      const params = {
        p: `${character}_${merchantId}_${merchantId}`
      }
      let domainUrl = this.$store.getters.platformConfig.h5Url
      RouterSwitchHelper.toProductDetails(domainUrl, record.proId, record.proType, 0, params)
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getProService().post('direct/fengYe/queryFengYeTeamList', params)
    }
  }
}
</script>

<style scoped>

</style>